/**
 * Copy + test IDs for the post-tutorial onboarding questionnaire.
 * See specs/onboarding-questionnaire/spec.md.
 */

export const ONBOARDING_TEST_IDS = {
  CONTAINER: 'onboarding-flow',
  BACK: 'onboarding-back',
  INTRO_CTA: 'onboarding-intro-cta',
  USERNAME_INPUT: 'onboarding-username-input',
  CHECK_BTN: 'onboarding-check-btn',
  CONTINUE_BTN: 'onboarding-continue-btn',
  LEAGUE_CHIP: 'onboarding-league-chip',
  LEAGUES_SEARCH: 'onboarding-leagues-search',
  LEAGUES_CTA: 'onboarding-leagues-cta',
  DONE_CTA: 'onboarding-done-cta',
  AGE_STEP: 'onboarding-age-step',
} as const;

export const ONBOARDING_COPY = {
  intro1Text: 'Welcome to Zporti!',
  intro1Cta: 'Let’s go 👋',
  intro2Text: 'Just three quick questions,\nthen we’re all set!',
  intro2Cta: 'Sounds Good!',

  agePrompt: 'First, a quick one.',

  namePrompt: 'What should I call you?',
  nameHeading: 'Pick your username',
  namePlaceholder: 'e.g. StreakMaster',
  nameHint: 'Pick a name, then check it’s free. Change it anytime.',
  checkIdle: 'Check',
  checkChecking: '…',
  checkFree: 'Free ✓',
  statusChecking: 'Checking availability…',
  statusAvailable: (name: string) => `✓ ${name} is available`,
  statusTaken: '✗ That one’s taken — try another',
  statusInvalid: '3–20 letters, digits, or underscores',
  statusProfanity: 'Please pick another name',
  statusError: 'Couldn’t check — try again',
  continue: 'Continue',

  leaguesPrompt: 'Which leagues do you follow?',
  leaguesHeading: 'Pick your leagues',
  leaguesSub: 'Choose all you love — we’ll tailor your slate.',
  leaguesSearchPlaceholder: 'Search leagues',
  leaguesNoMatches: 'No leagues match your search.',
  leaguesSkip: 'Skip for now',
  leaguesContinue: (n: number) => `Continue with ${n}`,
  leaguesEmpty: 'No leagues to show right now — you can pick favourites later.',

  doneTitle: (name: string) => `You’re all set, ${name}! 🎉`,
  doneSub: 'Your first slate is ready. Time to call it.',
  doneUsernameLabel: 'USERNAME',
  doneFollowingLabel: 'FOLLOWING',
  doneFollowingNone: 'None yet',
  doneFollowing: (n: number) => `${n} ${n === 1 ? 'league' : 'leagues'}`,
  doneCta: 'Start Predicting',
} as const;
